module.exports = __webpack_public_path__ + "fc498a94bec9eb6938d02a17faec3ea6.png";